export enum statusPaymentEnum {
    IN_PROGRESS='in_progess',
    DONE='completed',
    CANCELLED='canceled'
}

export enum paymentTypeEnum {
    PAYU='payu',
    PAYYPAL='paypal',
    PREPAID='prepaid',
    NORMAL='transfer'
}

export interface OrderManagementFrame {
    id?: Number;
    userId?: Number;
    offset?: Number;
    isPaid?: boolean;
    dateFrom?: Date;
    dateTo?: Date;
    isCreatedDocument?: boolean;
    status?: statusPaymentEnum;
    paymentType?: paymentTypeEnum;
    paymentFrom?: Date;
    paymentTo?: Date;
    invoices?: boolean;
}